import BRANDING_KEYS from '../constants/brandingKeysConst';

const numKeys = [
    BRANDING_KEYS.WIDGETS_BORDER_WIDTH,
    BRANDING_KEYS.WIDGETS_BORDER_RADIUS,
    BRANDING_KEYS.WIDGETS_BG_OPACITY,
    BRANDING_KEYS.GLOBAL_BTN_BORDER_RADIUS,
    BRANDING_KEYS.GLOBAL_BTN_BORDER_WIDTH,
];

const fixBool = (attributes) => {
    const fixedAttrs = attributes.map((attr) => {
        const attrClone = { ...attr };
        const { value } = attr;

        if (!value) {
            return attrClone;
        }

        const valLowercase = value.toLowerCase();

        if (valLowercase !== 'false' && valLowercase !== 'true') {
            return attrClone;
        }

        attrClone.value = valLowercase === 'true';

        return attrClone;
    });

    return fixedAttrs;
};

const fixNum = (attributes) => {
    const fixedAttrs = attributes.map((attr) => {
        const attrClone = { ...attr };
        const { key, value } = attr;
        const isNum = numKeys.indexOf(key) > -1;

        if (!isNum) {
            return attrClone;
        }

        attrClone.value = parseInt(value, 10);

        return attrClone;
    });

    return fixedAttrs;
};

const massageDataUtil = (attributes = []) => {
    const fixedBool = fixBool(attributes);
    const fixedNum = fixNum(fixedBool);

    return fixedNum;
};

export default massageDataUtil;
